export default __webpack_public_path__ + "static/media/hogsmeademagic.ba93a25c.png";